import { getMacroMappingOptions } from './bulkMappingHelpers';

export const useMappingOptions = (bulkPixels: MappingBulkPixels) => {
  const { data } = bulkPixels;

  const options = getMacroMappingOptions(data);

  return { options };
};
